import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import Icon from '../../components/Icon';
import { toolIcon, toolIconByIssueName } from '../../constants/toolIcons';
export const Name = ({ defect, onRuleClick }) => {
    let iconName = null;
    if (Object.prototype.hasOwnProperty.call(toolIcon, defect?.tool)) {
        iconName = toolIcon[defect.tool];
    }
    else if (Object.prototype.hasOwnProperty.call(toolIconByIssueName, defect.tool)) {
        iconName = toolIconByIssueName[defect.tool](defect.name);
    }
    return _jsxs("div", { className: clsx('flex-grow-1 text-truncate', onRuleClick && !defect.commitIssue && 'cursor--pointer'), onClick: () => (onRuleClick ? onRuleClick(defect.tool, defect.name) : void 0), children: [!iconName ? null : _jsx(Icon, { name: iconName, fixedWidth: true, className: 'mr-2', title: defect.tool }), defect.name] });
};
